/* unplugin-vue-components disabled */import { render } from "./MyOrder.vue?vue&type=template&id=8bc1fbc4&scoped=true"
import script from "./MyOrder.vue?vue&type=script&lang=js"
export * from "./MyOrder.vue?vue&type=script&lang=js"

import "./MyOrder.vue?vue&type=style&index=0&id=8bc1fbc4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator\\IdeaProjects\\haoma517-cust\\haoma517-customer-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bc1fbc4"]])

export default __exports__